module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e202321"
    }
  }, [_vm._v("Things to Remember ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e202821"
    }
  }, [_vm._v("The end of a thing is better than its beginning; the patient in spirit is better than the proud in spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e203921"
    }
  }, [_vm._v("ECCLESIASTES 7:8 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d9t00021"
    }
  }, [_vm._v("A hot-tempered man stirs up dissension, but a patient man calms a quarrel.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e206021"
    }
  }, [_vm._v("PROVERBS 15:18 NIV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e207521"
    }
  }, [_c('b', [_vm._v("Patience means living out the belief that God orders everything for the spiritual good of his children.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e209921"
    }
  }, [_c('b', [_vm._v("—J. I. PACKER ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e210821"
    }
  }, [_vm._v("We show we are servants of God by our pure lives, our understanding, patience, and kindness, by the Holy Spirit, by true love.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e212221"
    }
  }, [_vm._v("2 CORINTHIANS 6:6 NCV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e213821"
    }
  }, [_c('b', [_vm._v("The two most powerful warriors are patience and time.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e215221"
    }
  }, [_c('b', [_vm._v("—LEO TOLSTOY ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e216721"
    }
  }, [_vm._v("The Lord is not slack concerning His promise, as some count slackness, but is longsuffering toward us, not willing that any should perish but that all should come to repentance.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e218521"
    }
  }, [_vm._v("2 PETER 3:9 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e219921"
    }
  }, [_vm._v("For many years You had patience with them, and testified against them by Your Spirit in Your prophets. Yet they would not listen; therefore You gave them into the hand of the peoples of the lands.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e221721"
    }
  }, [_vm._v("NEHEMIAH 9:30 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e223121"
    }
  }, [_vm._v("Rest in the Lord, and wait patiently for Him.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e223921"
    }
  }, [_vm._v("PSALM 37:7 NKJV ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5347349d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c16_r1.vue
// module id = 96
// module chunks = 0